module.exports = __webpack_public_path__ + "media/images/payment_methods/klarna-51b040f644dc997b6d209132d1a8face.svg";